import { render, staticRenderFns } from "./userInfoPage.vue?vue&type=template&id=50defdb0&scoped=true&"
import script from "./userInfoPage.vue?vue&type=script&lang=js&"
export * from "./userInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./userInfoPage.vue?vue&type=style&index=0&id=50defdb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50defdb0",
  null
  
)

export default component.exports